import React, { useRef } from 'react'
import { Link } from 'react-router-dom'

import { useTranslate } from "../Context/LanguageContext"

const Professions = () => {

    const t = useTranslate("recruitment")

    const sliderRef = useRef(null)

    // Eine Card-Breite (18rem) + gap (4rem) ≈ 22rem. Wir scrollen 2 × 18rem.
    const SCROLL_AMOUNT = 18 * 16 * 2

    const left = () => {
        sliderRef.current?.scrollBy({ left: -SCROLL_AMOUNT, behavior: "smooth" })
    }
    const right = () => {
        sliderRef.current?.scrollBy({ left: SCROLL_AMOUNT, behavior: "smooth" })
    }

    // Pfeiltasten-Navigation innerhalb des Sliders
    const handleSliderKeyDown = (e) => {
        if (e.key === 'ArrowLeft') {
            e.preventDefault()
            left()
        } else if (e.key === 'ArrowRight') {
            e.preventDefault()
            right()
        }
    }

    const Card = ({ img, name }) => {
        return (
            <Link to="/contact" className='card'>
                <img
                    src={`./images/${img}.webp`}
                    alt={name}
                    loading='lazy'
                    decoding='async'
                />
                <h3>{name}</h3>
                <p className='contact'>{t("contact")} <span aria-hidden='true'>→</span></p>
            </Link>
        )
    }

    return (
        <section className='professions'>
            <h2>{t("success")}</h2>

            {/* Pfeile als <button> für Tastatur- und Screenreader-Support */}
            <button
                type='button'
                className='arrow left'
                onClick={left}
                aria-label='Previous'
            />
            <button
                type='button'
                className='arrow right'
                onClick={right}
                aria-label='Next'
            />

            <div
                className='slider'
                ref={sliderRef}
                role='region'
                aria-label={t("success")}
                tabIndex={0}
                onKeyDown={handleSliderKeyDown}
            >

                <Card name={t("care")} img={"nurse"} />

                <Card name={t("gastro")} img={"gastronomy"} />

                <Card name={t("logistics")} img={"logistics"} />

                <Card name={t("craft")} img={"craft"} />

                <Card name={t("it")} img={"it"} />

                <Card name={t("industrial")} img={"engineer"} />

                <Card name={t("construction")} img={"construction"} />

                <Card name={t("commercial")} img={"businessman"} />

            </div>

        </section>
    );
}

export default Professions;